import { Record, Map } from "immutable";
import moment from "moment";

const FormsRecord = Record({
  createFieldCategoriesTranslation: new (Record({
    isAddModalVisible: false,
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      locale: "",
      name: "",
      fieldCategoryUID: null,
      placeholder: "",
      description: ""
    }))()
  }))(),
  createFieldCategoriesTranslationSection: new (Record({
    disabled: false,
    isAddModalVisible: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      name: "",
      placeholder: "",
      sort: 1
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/fieldCategoriesTranslations/forms.js